import { useHConfig } from '../composables/use-helix-config';

export type Transforms = { [key: string]: Function };

export function getTransforms<T extends Object>(obj: T) {
  const transforms: Transforms = {};
  const initialTransformedValues = {} as T;
  const rawValues = {} as T;

  if (obj) {
    // Shallow transforms
    for (const key of Object.keys(obj)) {
      const _key = key as keyof typeof obj;
      const transform = obj[_key];

      if (typeof transform === 'function') {
        transforms[key] = transform;
        initialTransformedValues[_key] = transform();

        /*
          Make sure `key` is reserved in initial raw values independent of actual result of the interpolation.
          This is to make sure anything that uses this key receives an 'empty' value as transformations should only be applies right before sending the http request.
          
        */
        rawValues[_key] = undefined as T[keyof T];
      } else {
        initialTransformedValues[_key] = transform;
        rawValues[_key] = transform;
      }
    }
  }

  return {
    transforms,
    rawValues,
    initialValues: initialTransformedValues,
  };
}

export function applyTransforms<T extends Object>(obj: T, transforms: Transforms) {
  const resultObject = {} as T;

  if (obj) {
    for (const key of Object.keys(obj)) {
      const transform = transforms[key];
      const _key = key as keyof T;
      resultObject[_key] = transform ? transform(obj[_key]) : obj[_key];
    }
  }

  return resultObject;
}

export function isAbsoluteUrl(url: string) {
  // eslint-disable-next-line security/detect-unsafe-regex -- simple protocol-check pattern anchored at ^; no catastrophic backtracking risk
  const urlCheck = new RegExp('^(?:[a-z+]+:)?//', 'i');

  return urlCheck.test(url);
}

export function parseOnifyApiUrl(url: string) {
  const { hubApiPath } = useHConfig();

  return url.replace(hubApiPath, '');
}
